import { render, staticRenderFns } from "./WorkSiteEditor.vue?vue&type=template&id=84c950a2"
import script from "./WorkSiteEditor.vue?vue&type=script&lang=js"
export * from "./WorkSiteEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports